
@if (data.invalidRecords?.length > 0 || data.isDuplicateRecordExists) {
  <div mat-dialog-title>Orders cannot be added</div>
}

@if (data.invalidRecords?.length == 0 && ! data.isDuplicateRecordExists && data.activeOrderAcctNumSet?.length > 0) {
  <div mat-dialog-title>Active orders for accounts</div>
}

<mat-dialog-content>
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
  @if (data.isDuplicateRecordExists) {
    <div class="error block">
      You cannot add multiple orders for the same symbol into the same account.<br/>
      Please remove duplicate symbols for the accounts you want to import to, and try again.
    </div>
  }

  @if (data.invalidRecords?.length > 0) {
    <div class="warn block">
        Your request includes invalid records.<br/>
        The records listed below will not get added.
    </div>
  }

  @if (data.invalidRecords?.length == 0 && ! data.isDuplicateRecordExists && data.activeOrderAcctNumSet?.length > 0) {
    <div class="block">
      <div class="block">There are active orders on the iRebal order blotter for the accounts listed below.<br/>
      Before approving, check the active orders and make sure that the ones you are approving now are not duplicates.</div>
      <div style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
        <table width="100%" >
          @for (orders of data.activeOrderAcctNumSet; track orders) {
            <tr>
              <td>
                <strong>{{orders}}</strong>
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  }

  @if (data.invalidRecords?.length > 0 || data.isDuplicateRecordExists) {
    <div>
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'240px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [frameworkComponents] = 'frameworkComponents'
        [rowData] = "data.isDuplicateRecordExists ? data.duplicateRecords : data.invalidRecords"
      (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel all additions</button>
  <button id="continueButton" (click)="proceed()" [disabled]="!(data.validRecords?.length > 0)" class="btn-medium-primary">Finish</button>
</mat-dialog-actions>
